import styled from "@emotion/styled";
import { Button, Box } from "@mui/material";

export const GradientButton = styled(Button)(({ theme }) => ({
  borderRadius: "4px",
  boxShadow:
    "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)",
  background:
    "linear-gradient(265.05deg, rgba(253, 92, 72, 0.9) 0%, rgba(255, 3, 50, 0.9) 7.28%, rgba(234, 1, 129, 0.9) 14.09%, rgba(155, 0, 120, 0.9) 24.86%, rgba(77, 0, 102, 0.9) 39.99%, rgba(0, 0, 84, 0.9) 52.05%, rgba(0, 0, 84, 0.9) 60.94%), linear-gradient(92.85deg, rgba(253, 92, 72, 0.9) 0.41%, rgba(255, 3, 50, 0.9) 20.64%, rgba(234, 1, 129, 0.9) 33.6%, rgba(155, 0, 120, 0.9) 50.2%, rgba(77, 0, 102, 0.9) 65.76%, rgba(0, 0, 84, 0.9) 85.48%, rgba(0, 0, 84, 0.9) 100%)",
}));

// export const BasicSearchStoryContainer = styled.div<{ width?: number }>`
//   ${({ width }) => css`
//     width: ${width || 200}px;
//   `};

//   @media (max-width: ${Breakpoints.MD}) {
//     width: 100%;
//   }
// `;

export const JourneyWrapper = styled.div`
  height: 100vh;
  overflow: auto;
  .Mui-focused {
    .MuiOutlinedInput-notchedOutline {
      border-width: 1px !important;
    }
    &:not(.Mui-error) {
      .MuiOutlinedInput-notchedOutline {
        border-color: rgba(58, 53, 65, 0.22) !important;
      }
    }
  }
  &::-webkit-scrollbar {
    width: 8;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: #e3e4e4;
    borderradius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: red;
  }

  display: flex;
  flex-wrap: wrap;
  gap: 50px;
  padding: 50px;
  background: #fff;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: 600px) {
    gap: 30px;
    padding: 15px;
  }
  * {
    font-family: "Satoshi";
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  button,
  span,
  input,
  label {
    font-family: "Satoshi" !important;
  }

  p {
    font-size: 16px;
    font-weight: 500;
  }

  .button-primary {
    background: #ed0057 !important;
    mix-blend-mode: normal;
    color: #fff !important;
    text-transform: none;
  }
  .button-primary[disabled] {
    background: #acadaf !important;
  }

  .button-primary-outlined {
    border-color: #ed0057 !important;
    mix-blend-mode: normal;
    color: #ed0057 !important;
    background: none !important;
    text-transform: none;
  }
  .button-primary-outlined[disabled] {
    border-color: #acadaf !important;
    mix-blend-mode: normal;
    color: #acadaf !important;
    background: none !important;
  }
  .MuiLink-root {
    color: #ed0057;
  }
`;

export const JourneyWrapperRight = styled.div`
  padding: 50px;
  color: #fff;
  background-size: cover;
  display: flex;
  gap: 100px;
  flex-direction: column;
  justify-content: space-between;
  min-width: 50%; //max-width: 655px;
  min-width: 400px;
  @media (max-width: 600px) {
    padding: 30px;
    min-width: auto;
  }
  flex: 1;
  min-height: calc(100vh - 100px);
  border-radius: 24px;
  position: sticky;
  top: 0px;
  .contentMid {
    h1 {
      font-size: 36px;
      margin: 0;
      margin-bottom: 16px;
      font-weight: 600;
      span {
        color: #ed0057;
        font-weight: 600;
      }
    }
    p {
      font-size: 14px;
      margin: 0;
      font-weight: 200;
    }
  }

  .contentBottom {
    text-align: center;
    p {
      margin: 0;
      margin-bottom: 30px;
      font-weight: 400;
    }
    ul {
      display: flex;
      gap: 40px;
      flex-wrap: wrap;
      padding: 0;
      align-items: center;
      justify-content: center;
      li {
        display: block;
        min-width: 20%;
      }
    }
  }
  gap: 20px;
  min-width: 600px;
  color: #222529;
  @media (max-width: 1160px) {
    position: static;
  }
  .contentMid {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    h1 {
      font-size: 32px;
      color: #ed0057;
      text-align: center;
      margin-bottom: 16px;
      font-weight: 600;
    }
    p {
      font-size: 18px;
      margin: 0;
      margin-top: 16px;
      margin-bottom: 16px;
      font-weight: 200;
      text-align: center;
      font-weight: 500;
      a {
        font-weight: 700;
        color: #222529;
      }
    }
    h2 {
      color: #222529;
      font-weight: 700;
    }
  }
  .stapper {
    max-width: 500px;
    width: 100%;
    background: linear-gradient(
      90deg,
      rgba(237, 0, 87, 0.1) 0%,
      rgba(255, 92, 74, 0.1) 92.28%
    );
    border-radius: 6px;
    padding: 24px;
    .MuiStepper-root {
      .MuiStep-root {
        flex: 1;
        padding: 0;
        circle {
          color: #fff;
        }
        text {
          fill: #ed0057;
        }
        &:first-child {
          circle {
            color: #ed0057;
          }
          text {
            fill: #fff;
          }
        }
        .Mui-active {
          .MuiStepLabel-iconContainer {
            border: 1px solid #f91358;
            border-radius: 100px;
            margin-top: -1px;
          }
        }
        .MuiStepLabel-label {
          font-size: 16px !important;
          color: #222529 !important;
          font-weight: 500;
          margin-top: 10px;
        }
        &.mid {
          svg.MuiSvgIcon-root {
            border: 1px solid #f91358;
            border-radius: 100px;
          }
        }
      }
      .MuiStepConnector-root {
        .MuiStepConnector-line {
          border-color: #fff;
        }
        &.Mui-active {
          .MuiStepConnector-line {
            border-color: #ed0057;
          }
        }
      }
    }
    @media (max-width: 600px) {
      .MuiStepper-root {
        flex-direction: column;
        gap: 30px;
        align-items: center;
        .MuiStepConnector-root {
          display: none;
        }
      }
    }
  }
  .contentBottom {
    text-align: center;
    p {
      margin: 0;
      margin-bottom: 16px;
      font-size: 20px;
      font-weight: 700;
    }
    ul {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      li {
        display: flex;
        gap: 5px;
        align-items: center;
        min-width: auto;
        a {
          color: #ed0057;
          text-decoration: underline;
          font-weight: 500;
        }
      }
    }
  }
`;

export const JourneyWrapperLeft = styled.div`
  flex: 1;
  min-width: 400px;
  .content {
    //max-width: 600px;
    margin: auto;
  }
  h1 {
    font: 32px;
    color: #222529;
  }
  @media (max-width: 600px) {
    min-width: auto;
  }
`;
export const StepperStyledWrap = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 50px;
`;
export const HeadTitleStyled = styled.h2`
  font-size: 32px;
  color: #222529;
  margin: 0;
  margin-bottom: 15px;
  font-weight: 700;
`;
export const FieldLabelStyled = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #3e4044;
  margin-bottom: 5px;
  span.required {
    color: #ed0057;
  }
  svg[data-testid="InfoOutlinedIcon"] {
    cursor: pointer;
  }
`;

export const ErrorMessageFieldStyled = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #ed0057;
  margin-bottom: 5px;
  padding: 5px;
`;
export const CheckboxWrapStyled = styled(Box)`
  display: flex;
  gap: 5px;
  margin-left: -10px;
  align-items: flex-start;
  > div {
    display: block;
    padding-top: 8px;
  }
`;
export const OtpInputWrapStyled = styled.div`
  margin-top: 30px;
  margin-bottom: 16px;
  > div {
    display: flex;
    gap: 12px;
    // max-width: 560px;
    gap: 20px;
    margin: auto;
  }

  input {
    flex: 1;
    height: 82px;
    border: 1px solid #c8c8c9;
    font-size: 24px;
    font-weight: bold;
  }
`;
export const GoBackStyled = styled.div`
  display: inline-flex;
  gap: 10px;
  font-size: 16px;
  color: #222529;
  font-weight: 500;
  margin-bottom: 14px;
  cursor: pointer;
`;
export const EligibilityStyled = styled.div`
  padding: 24px;
  display: flex;
  gap: 24px;
  background-size: cover;
  align-items: flex-start;
  > img {
    margin: 11px 0;
  }
  p {
    font-size: 18px;
    color: #222529;
    margin: 0;
  }
  h3 {
    font-size: 40px;
    color: #ff5c4a;
    margin: 0;
    font-weight: 600;
    word-break: break-all;
  }

  @media (max-width: 600px) {
    justify-content: center;
    align-items: center;
    img {
      max-width: 150px;
      margin: auto;
      width: 100%;
    }
    flex-direction: column;
  }
`;

export const ModalContentStyled = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  button,
  span,
  input,
  label {
    font-family: "Satoshi" !important;
  }

  padding: 32px;
  padding-top: 28px;
  background: #fff;
  border-radius: 16px;
  max-width: 900px;
  width: calc(100% - 30px);
  margin: auto;
  margin-top: 50px;
  max-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  @media (max-width: 600px) {
    margin-top: 15px;
    max-height: calc(100vh - 100px);
    padding: 20px;
    padding-top: 20px;
  }
  .head {
    position: sticky;
    top: 0;
    display: flex;
    align-items: flex-start;
    padding-bottom: 24px;
    > svg {
      margin-top: 14px;
      cursor: pointer;
    }
    > div {
      flex: 1;
      h3 {
        font-size: 24px;
        color: #000329;
        font-weight: 700;
        margin: 0;
      }
      p {
        font-size: 16px;
        color: #3e4044;
        font-weight: 500;
        margin: 0;
        a {
          color: #ed0057;
          font-weight: 500;
          span {
            text-decoration: underline;
            font-weight: 500;
          }
        }
      }
    }
  }
  .content {
    padding: 0;
    display: flex;
    flex: 1;
    overflow: auto;
    margin: 0 -32px;
    padding: 0 32px;
    &.verticleTabWrap {
      gap: 20px;
    }
    .MuiTabs-vertical {
      min-width: 240px;
      margin: 0;
    }
    .MuiTabs-flexContainer {
      padding-right: 16px;
      gap: 8px;
      .MuiTab-root {
        align-items: center;
        padding: 12px 16px;
        color: #222529;
        text-transform: none;
        border-radius: 4px;
        flex-direction: row;
        justify-content: flex-start;
        gap: 5px;
        min-height: 48px;
        &.Mui-selected {
          color: #ed0057;
          background: #fef4f8;
          font-weight: 600;
        }
        &.MuiTab-labelIcon {
          font-weight: 600;
        }
      }
    }
    .MuiTabs-indicator {
      display: none;
    }

    @media (max-width: 600px) {
      margin: 0 -20px;
      padding: 0 20px;
      &.verticleTabWrap {
        flex-direction: column;
        display: block;
        .MuiTabs-vertical {
          border-right: none;
          .MuiTabs-scroller {
            height: auto;
          }
          .MuiTabs-flexContainer {
            padding: 0;
            .MuiTab-root {
              width: 100%;
              max-width: none;
            }
          }
        }
      }
      ul.MuiList-root li.MuiListItem-root {
        width: 100%;
        .file-content .MuiTypography-root {
          word-break: break-all;
        }
      }
    }
  }
  .foot {
    display: flex;
    padding-top: 24px;
    gap: 16px;
    justify-content: flex-end;
    button {
      max-width: 120px;
      width: 120px;
    }
    .button-primary {
      background: #ed0057 !important;
      mix-blend-mode: normal;
      color: #fff !important;
      text-transform: none;
    }
    .button-primary[disabled] {
      background: #acadaf !important;
    }

    .button-primary-outlined {
      border-color: #ed0057 !important;
      mix-blend-mode: normal;
      color: #ed0057 !important;
      background: none !important;
      text-transform: none;
    }
    .button-primary-outlined[disabled] {
      border-color: #acadaf !important;
      mix-blend-mode: normal;
      color: #acadaf !important;
      background: none !important;
    }
  }
`;
export const UploadStatementStyled = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: cenetr;
  text-align: center;
  flex-direction: column;
  gap: 5px;
  .icon {
    width: 66px;
    height: 66px;
    border: 1px solid #e3e4e4;
    border-radius: 4px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .done {
      position: absolute;
      top: -10px;
      right: -10px;
    }
  }
  p {
    font-size: 12px;
    margin: 0;
    margin-bottom: 10px;
  }
`;

export const FeedbackRadioStyled = styled.div`
  .icon {
    width: 66px;
    height: 66px;
    border: 1px solid #e3e4e4;
    border-radius: 4px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  p {
    font-size: 12px;
    margin-bottom: 10px;
  }
`;
export const CountrySelectStyled = styled.div`
  button[class*="ReactFlagsSelect-module"] {
    min-height: 56px;
    padding: 12px 14px !important;
    > span {
      padding-left: 0px;
    }
  }
`;

export const SelectRegionStyled = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin: -12px;
  padding: 15px 14px 12px 13px;
  background: #f9fbfc;
  .MuiButton-root {
    max-width: 100px;
  }
  @media (max-width: 600px) {
    flex-direction: column;
    button {
      width: 100% !important;
      max-width: none !important;
    }
  }
`;
export const WhyChooseStyled = styled.ul`
  padding: 0;
  margin-top: 48px;
  li {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    p {
      margin: 0;
      padding-top: 12px;
      font-size: 16px;
      color: #000;
    }
  }
`;
export const TestimonialStyled = styled.ul`
  background: #2d2d6a;
  padding: 24px;
  padding-top: 44px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-radius: 16px;
  .icon {
    position: absolute;
    left: 20px;
    top: -30px;
  }
  h3 {
    color: #fff;
    font-size: 30px;
    margin: 0px;
    font-weight: 500;
  }
  p {
    font-size: 18px !important;
    color: #fff;
  }
  p.small {
    font-size: 14px !important;
    strong {
      font-size: 16px !important;
    }
  }
  .sap {
    height: 1px;
    background: rgba(88, 90, 168, 1);
  }
`;
export const ThankyouDetail = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 40px;
  li {
    display: flex;
    gap: 10px;
    .left,
    .right {
      background: #fff;
      padding: 5px 10px;
      flex: 1;
      text-align: left;
    }
    .left {
      min-width: 150px;
      font-weight: 700;
    }
    .right {
      min-width: 250px;
      font-weight: 400;
    }
  }
`;
